<template>
  <div class="good-detail-box pdd-detail-box">
    <van-nav-bar title="苏宁易购商品详情" fixed left-arrow @click-left="$router.go(-1)" />
     <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <div
          class="good-img"
          :style="{ 'background-image': 'url(' + image.picUrl + ')' }"
        ></div>
      </van-swipe-item>
    </van-swipe>

    <div class="good-body">
      <div class="price-content">
        <div class="coupon-price">券后价：￥<span class="price">{{ goodInfo.arrivalPrice }}</span></div>
        <div class="original-price">原价:￥{{goodInfo.commodityInfo.snPrice}}</div>
        <div class="volume">
          热销 <span class="c-red">{{ goodInfo.commodityInfo.monthSales }}</span> 件
        </div>
      </div>
      <div class="name-content">
        <span class="name">
          {{ goodInfo.commodityInfo.commodityName }}
        </span>
      </div>
      <div class="coupon-content" v-if="goodInfo.couponInfo.activityId">
        <van-tag plain size="large" type="danger">{{goodInfo.couponInfo.couponValue}}元券</van-tag>
      </div>
      <div class="commission-content">
        <van-icon name="after-sale" /> 当前佣金
        <span class="commission">￥{{promotion_rate}} </span> 元
      </div>
      <div class="info">

        <span style="padding-right:15px;">{{goodInfo.commodityInfo.sellingPoint}}</span>
      </div>
    </div>
    <div style="height: 55px"></div>
    <van-goods-action>
      <van-goods-action-icon
        icon="shop-o"
        text="首页"
        @click="$router.push('/')"
      />
      <!-- <van-goods-action-button
        type="warning"
        :text="`分享赚 ${promotion_rate} 元`"
        @click="doCopy"
      />
      <van-goods-action-button
        type="danger"
        :text="`立即买省 ${promotion_rate} 元`"
        @click="doCopy"
      /> -->
      <van-goods-action-button
        type="warning"
        :text="`分享`"
        @click="doCopy"
      />
      <van-goods-action-button
        type="danger"
        :text="`立即买`"
        @click="doCopy"
      />
    </van-goods-action>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      goodInfo: {
        commodityInfo:{},
        couponInfo:{},
      }, //商品详情
      images: [], //轮播图
      commodityList:[], //相关推荐列表
    };
  },
   computed: {
    ...mapState(["rate"]),
    // 佣金折算
     promotion_rate() {
      return (
        ((this.goodInfo.arrivalPrice) *
          (this.goodInfo.commodityInfo.rate / 100) *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  created() {
    // 商品详情
    this.Post({ 
      id: this.$route.query.id,
      code:this.$route.query.code
      }, "/sunning/commoditydetail", (res) => {
      if (res.states == 1) {
        let Data =  res.data.sn_responseContent.sn_body.queryCommoditydetail[0] || {};
        this.goodInfo = Data;
        this.images = Data.commodityInfo.pictureUrl;
      }
    });
    // 关联的相关推荐商品
    this.Post({ id: this.$route.query.id }, "/sunning/morerecommend", (res) => {
      if (res.states == 1) {
        let Data = res.data.sn_responseContent.sn_body.getMorerecommend.commodityList || [];
        this.commodityList = Data;
      }
    });
  },
  methods: {
    // 复制链接
    doCopy() {
      this.$router.push("/sunning/share?id=" + this.goodInfo.commodityInfo.commodityCode + '&code='+this.goodInfo.commodityInfo.supplierCode);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '../../assets/less/good.less';
</style>



// WEBPACK FOOTER //
// src/pages/sunning/detail.vue